export const queryURL = (status, apiUrl, customerId) => {
  return status === "SKIPPED"
    ? `${apiUrl}/api/customers/${customerId}/charges/unskip`
    : `${apiUrl}/api/customers/${customerId}/charges/skip`;
};

export const dietTypeSubtitle = (mealsList) => {
  let _data = [...mealsList];

  if (!_data.length) return "Low-FODMAP";

  if (_data[0].variants[0].sku.startsWith("MD")){
    return "Mediterranean";
  }
  if (_data[0].variants[0].sku.startsWith("LF")){
    return "Low-FODMAP";
  }
  if (_data[0].variants[0].sku.startsWith("DF")){
    return "Diabetes-Friendly";
  }
  if (_data[0].variants[0].sku.startsWith("GF")){
    return "Gluten-Free";
  }
  if (_data[0].variants[0].sku.startsWith("HF")){
    return "Heart-Friendly";
  }
  if (_data[0].variants[0].sku.startsWith("CC")){
    return "Carb-Conscious";
  }
  if (_data[0].variants[0].sku.startsWith("B2B")){
    return "B2B";
  }
  if (_data[0].variants[0].sku.startsWith("MCD")){
    return "Care";
  }
};
